// src/services/financeiro/FormaPagService.js
import { fetchData, postData, putData, deleteData } from '../Api.js';
import { parseNumeric } from '../../utils/numberUtils.js';

export const buscarFormasPag = () => fetchData('/FormaPag');
export const adicionarFormaPag = forma => postData('/FormaPag', { ...forma, descontoDelivery: parseNumeric(forma.descontoDelivery) });
export const atualizarFormaPag = forma => putData('/FormaPag', { ...forma, descontoDelivery: parseNumeric(forma.descontoDelivery) });
export const excluirFormaPag = id => deleteData('/FormaPag', { formaPagId: id });
